export default "__VITE_ASSET__ggPW6$_B__"